import React from "react";
import { motion } from "framer-motion";
import Tilt from "react-parallax-tilt";
import myImg from "../../Assets/avatar.svg";
import { AiFillGithub } from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";

function Home2() {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: { 
      opacity: 1,
      transition: { 
        staggerChildren: 0.2,
        delayChildren: 0.3 
      } 
    }
  };

  const itemVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: { y: 0, opacity: 1 }
  };

  return (
    <section className="relative py-20 bg-dark-accent/30 overflow-hidden" id="about">
      <div className="container mx-auto px-4 md:px-8">
        <motion.div 
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          className="grid grid-cols-1 lg:grid-cols-12 gap-8"
        >
          {/* Bento Card: Introduction */}
          <motion.div 
            variants={itemVariants}
            className="lg:col-span-8 glass p-8 rounded-3xl border-white/5 space-y-6"
          >
            <h2 className="text-3xl md:text-5xl font-bold font-manrope">
              LET ME <span className="text-primary italic">INTORDUCE</span> MYSELF
            </h2>
            
            <div className="space-y-4 text-neutral-400 text-lg leading-relaxed">
              <p>
                I am a passionate <span className="text-primary font-semibold">Full Stack Developer</span> with expertise in 
                <span className="text-neon font-mono mx-1">React.js, Node.js, FastAPI</span> and cloud platforms like 
                <span className="text-neon font-mono mx-1">Azure</span>.
              </p>
              
              <p>
                Currently, at <span className="text-white font-semibold">GrapheneAI</span>, I develop AI-driven web solutions, 
                cloud deployments, and microservices architecture.
              </p>

              <p>
                My field of interest includes building 
                <span className="text-primary italic mx-1">modern web technologies and AI-powered products</span>. 
                I love working on scalable web applications and optimizing APIs for performance.
              </p>
              
              <p className="border-l-4 border-neon/30 pl-4 py-2 italic bg-neon/5 rounded-r-lg">
                "One of my key projects was an All-in-One Image Transformation Toolkit using React.js, MongoDB, and Cloudinary."
              </p>
            </div>
          </motion.div>

          {/* Bento Card: Avatar */}
          <motion.div 
            variants={itemVariants}
            className="lg:col-span-4 flex items-center justify-center p-8 bg-surface/40 rounded-3xl border-white/5 relative group"
          >
            <div className="absolute inset-0 bg-primary/10 blur-3xl rounded-full scale-75 group-hover:scale-100 transition-transform duration-700"></div>
            <Tilt perspective={1000} scale={1.05} transitionSpeed={2500}>
              <img src={myImg} className="w-64 h-64 md:w-80 md:h-80 relative z-10" alt="avatar" />
            </Tilt>
          </motion.div>

          {/* Bento Card: Socials */}
          <motion.div 
            variants={itemVariants}
            className="lg:col-span-12 glass p-8 rounded-3xl border-white/5 flex flex-col md:flex-row items-center justify-between gap-8"
          >
            <div className="text-center md:text-left">
              <h3 className="text-2xl font-bold font-manrope text-white">FIND ME ON</h3>
              <p className="text-neutral-500">Feel free to <span className="text-primary">connect</span> with me</p>
            </div>
            
            <ul className="flex gap-6">
              {[
                { icon: <AiFillGithub size={28}/>, url: "https://github.com/vijay5599", label: "GitHub" },
                { icon: <FaLinkedinIn size={28}/>, url: "https://www.linkedin.com/in/vijay-v-benal-184926169/", label: "LinkedIn" }
              ].map((social, index) => (
                <motion.li key={index} whileHover={{ y: -5 }}>
                  <a
                    href={social.url}
                    target="_blank"
                    rel="noreferrer"
                    aria-label={social.label}
                    className="w-14 h-14 rounded-2xl flex items-center justify-center bg-dark border border-white/10 text-primary hover:text-neon hover:border-neon/50 transition-all shadow-[0_4px_20px_rgba(0,0,0,0.3)]"
                  >
                    {social.icon}
                  </a>
                </motion.li>
              ))}
            </ul>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
}

export default Home2;
